import { Injectable } from '@angular/core';

@Injectable()
export class SetFunctionsService {
  public functions = [
                {
                    tex: 'x(x+2)(x-2)',
                    fnc: (x)=>x*(x+2)*(x-2),
                    derivative: (x)=>3*Math.pow(x,2)-4,
                    text: 'Eine punktsymmetrische ganzrationale Funktion mit Nullstelle bei 2.'
                },
                {
                    tex: '-{{1}\\over{4}} x^5-2,5x^3+2,25x',
                    fnc: (x)=>-0.25*x*(x+1)*(x-1)*(x-3)*(x+3),

                    //MINUS VERGESSEN BEI DER ABLEITUNG!!!
                    derivative: (x)=>1.25*Math.pow(x,4)-7.5*Math.pow(x,2)+2.25,
                    
                    text: 'Eine punktsymmetrische ganzrationale Funktion mit negativem Koeffizienten vor der höchsten x-Potenz.'
                },
                {
                    tex: '{{3}\\over{100}}x^2 (x-3)(x+6)',
                    fnc: (x)=>0.03*x*x*(x-3)*(x+6),
                    derivative: (x)=>0.12*Math.pow(x,3) + 0.27*Math.pow(x,2)-1.08*x,
                    text: 'Eine ganzrationale Funktion 4. Grades, deren Graph den Ursprung berührt.'
                },
                {
                    tex: '(x+2)(x-1)^2',
                    fnc: (x)=>(x+2)*(x-1)*(x-1),
                    derivative: (x)=>3*Math.pow(x,2)-3,
                    text: 'Eine ganzrationale Funktion 3. Grades mit doppelter Nullstelle bei 1.'
                },
                {
                    tex: 'x',
                    fnc: (x)=>x,
                    derivative: (x)=>1,
                    text: 'Der Graph dieser Funktion ist eine Ursprungsgerade mit 100% Steigung .'
                },
                {
                    tex: '{{1}\\over{2}} x-2',
                    fnc: (x)=>.5*x-2,
                    derivative: (x)=>.5,
                    text: 'Eine lineare Funktion mit Steigungsfaktor 0,5 und Nullstelle (4|0)'
                },
                {
                    tex: '\\frac{1}{2}x',
                    fnc: (x)=>.5*x,
                    derivative: (x)=>.5,
                    text: 'Eine lineare Funktion, mit Nullstelle bei Null und Steigungsfaktor 0,5.'
                },
                {
                    tex: '4x',
                    fnc: (x)=>4*x,
                    derivative: (x)=>4,
                    text: 'Eine lineare Funktion, deren Graph die Normalparabel in ihrem Scheitelpunkt und bei (4|16) schneidet.'
                },

                {
                    tex: 'x^2+1',
                    fnc: (x)=>Math.pow(x,2)+1,
                    derivative: (x)=>2*x,
                    text: 'Die Normalparabel um eins nach oben verschoben.'
                },
                {
                    tex: 'x^2',
                    fnc: (x)=>Math.pow(x,2),
                    derivative: (x)=>2*x,
                    text: 'Eine Normalparabel.'
                },
                {
                    tex: '(x-4)^2',
                    fnc: (x)=>Math.pow(x-4,2),
                    derivative: (x)=>2*x-8,
                    text: 'Eine um vier nach rechts verschobene Normalparabel.'
                },
                {
                    tex: '(x+4)^2',
                    fnc: (x)=>Math.pow(x+4,2),
                    derivative: (x)=>2*x+8,
                    text: 'Eine um vier nach links verschobene Normalparabel.'
                },
                {
                    tex: 'x^2-x',
                    fnc: (x)=>Math.pow(x,2)-x,
                    derivative: (x)=>2*x-1,
                    text: 'Eine quadratische Funktion mit Nullstellen (0|0) und (1|0).'
                },
                {
                    tex: 'x^2-4',
                    fnc: (x)=>Math.pow(x,2)-4,
                    derivative: (x)=>2*x,
                    text: 'Eine Funktion mit Nullstellen bei 2 und -2 und sonst nirgends.'
                },
                {
                    tex: 'x^2+2',
                    fnc: (x)=>Math.pow(x,2)+2,
                    derivative: (x)=>2*x,
                    text: 'Eine quadratische Funktion, deren Wertemenge nur Elemente größer gleich 2 enthält, und achsensymmetrisch zur y-Achse ist.'
                },


                {
                    tex: 'x^{\\frac{1}{2}}',
                    fnc: (x)=>Math.sqrt(x),
                    derivative: (x)=>.5/Math.sqrt(x),
                    text: 'Eine Potenzfunktion, deren Graph durch (4|2) verläuft.',
                    def: 'ℝ⁺'
                },
                {
                    tex: 'x^{-1}',
                    fnc: (x)=>1/x,
                    derivative: (x)=>-1/Math.pow(x,2),
                    text: 'Eine Potenzfunktion, deren Graph keine Achse berührt und durch den Punkt (10|0,1) verläuft.',
                    def: 'ℝ\\{0}',
                    defExceptions: [0]
                },                
/*
                {
                    tex: '|x|',
                    fnc: (x)=>Math.abs(x),
                    derivative: (x)=>undefined,
                    text: 'Die Betragsfunktion.',
                },            */         

                {
                    tex: '0',
                    fnc: (x)=>0,
                    derivative: (x)=>0,
                    text: 'Eine konstante Funktion mit unendlich vielen Nullstellen.',
                }
            ]
}